import { useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { Destination } from '@marageti/z4-sdk/lib/travel';
import { useMemo } from 'react';

type UseDestinationsReturn = {
  destinationsList: Destination[];
  isLoading: boolean;
};

const useDestinations = (destinations: string[] | undefined): UseDestinationsReturn => {
  if (!destinations) {
    return {
      destinationsList: [],
      isLoading: false,
    };
  }
  const apiClient = useApiClient();
  const {
    data,
    isLoading,
  } = useFetchImmutable<Destination[]>(
    apiClient.destinationsClient.getDestinations,
    [{ params: { all: true } }],
    true,
  );

  const destinationsMap = useMemo(() => data?.reduce((acc, dest) => {
    acc[dest.id] = dest;
    return acc;
  }, {} as Record<string, Destination>), [data]);

  const destinationsList = useMemo(() => destinations.map((destId) => destinationsMap?.[destId]).filter((dest): dest is Destination => Boolean(dest)), [destinations, destinationsMap]);

  return {
    destinationsList: isLoading ? [] : destinationsList || [],
    isLoading,
  };
};

export default useDestinations;
